import { useEffect } from "react";
import { useForm } from "@inertiajs/react";
import ProductForm from "@/pages/products/product-form";
import { buildProductFormData } from "@/pages/products/form-utils";
import { handleDrawerSuccess, hasArrayErrors } from "@/lib/drawer-submission";
import { manage_products_path } from "@/routes";

export default function ProductCreateDrawer({ product = {}, errors = [], onSuccess, onProcessingChange = null }) {
  const { data, setData, post, processing } = useForm(buildProductFormData(product));

  useEffect(() => {
    setData(buildProductFormData(product));
  }, [product, setData]);

  useEffect(() => {
    onProcessingChange?.(processing);
  }, [onProcessingChange, processing]);

  const submit = (event) => {
    event.preventDefault();
    post(manage_products_path(), {
      preserveScroll: true,
      onSuccess: (page) => handleDrawerSuccess(
        page,
        (props) => props.show_create_product_drawer || hasArrayErrors(props, "create_errors"),
        onSuccess
      ),
    });
  };

  return (
    <ProductForm
      data={data}
      setData={setData}
      errors={errors}
      processing={processing}
      onSubmit={submit}
      submitLabel="Opret produkt"
      layout="drawer"
    />
  );
}
